/**
 * Feature flag — online payments (Stripe).
 *
 * Baked at build time from REACT_APP_ONLINE_PAYMENTS_ENABLED (docker build arg in
 * production; unset locally). When false the admin hides Stripe Connect and
 * disables the settings that can't work without a card capture (card on booking,
 * pre-authorization, event deposit). Backend (payment-service / discovery)
 * enforces the same flag, so this is UX only. Defaults to ENABLED so local dev
 * is unchanged.
 */
export const ONLINE_PAYMENTS_ENABLED: boolean =
    (process.env.REACT_APP_ONLINE_PAYMENTS_ENABLED ?? 'true').toLowerCase() !== 'false';
